/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_Blocked_SystemInputs */



/**
* | output |
* | --- |
* | "Your computer is blocking the microphone for your browser. Check your computer's privacy settings, or ask your IT team." |
*
* @param {Practice_Session_Mic_Blocked_SystemInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_blocked_system = /** @type {((inputs?: Practice_Session_Mic_Blocked_SystemInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_Blocked_SystemInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je computer blokkeert de microfoon voor je browser. Kijk bij de privacy-instellingen van je computer of vraag het aan je IT-dienst.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre ordinateur bloque le micro pour votre navigateur. Vérifiez les paramètres de confidentialité de votre ordinateur ou demandez à votre service informatique.")
	return /** @type {LocalizedString} */ ("Your computer is blocking the microphone for your browser. Check your computer's privacy settings, or ask your IT team.")
});